module.exports = __webpack_public_path__ + "static/img/news35_9.7490993.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/report/news35/news35_9.png
// module id = fGST
// module chunks = 0